"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const fos_ui_1 = require("@ntet/fos-ui");
const react_1 = require("react");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const fp_1 = require("lodash/fp");
const utils_1 = require("./utils");
// eslint-disable-next-line max-lines-per-function
const DefaultNotification = ({ name, actionTypeName, projectName, triggerType, programEventName, item, statusID, notificationID, triggerTimestamp, dueDate, onOperation = fp_1.noop, operations, }) => {
    const [operationInProgress, setOperationInProgress] = (0, react_1.useState)(false);
    const validOperations = (0, react_1.useMemo)(() => {
        if (operations) {
            return operations;
        }
        switch (statusID) {
            case 2:
                return ['Complete', 'Cancel'];
            case 3:
                return ['Acknowledge', 'Close'];
            case 4:
            case 6:
                return ['Approve'];
            case 0:
            case 1:
            case 5:
            case 7:
            default:
                return [];
        }
    }, [statusID]);
    const iconLetter = (0, react_1.useMemo)(() => {
        if (statusID === 4 || statusID === 6) {
            return 'A';
        }
        if (actionTypeName === 'Alert') {
            return 'i';
        }
        // must be task
        return 'T';
    }, [actionTypeName, statusID]);
    const onOperationWrapper = (0, react_1.useCallback)((operation, notificationID) => {
        const callback = (wasSuccessful) => {
            setOperationInProgress(false);
        };
        setOperationInProgress(true);
        onOperation(operation, notificationID, callback);
    }, [onOperation, setOperationInProgress]);
    const isOverdue = (0, react_1.useMemo)(() => dueDate && dueDate < utils_1.NOW_DATE, [dueDate]);
    const timeSinceTrigger = (0, react_1.useMemo)(() => (0, utils_1.calculateDifferenceFromTodaysDate)(triggerTimestamp), [triggerTimestamp]);
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsxs)(IconContainer, { children: [isOverdue && (0, jsx_runtime_1.jsx)(fos_ui_1.Icon, { name: 'status_error', className: 'error-icon' }), (0, jsx_runtime_1.jsx)(fos_ui_1.ToolTip, Object.assign({ infoText: projectName, placement: 'right-start' }, { children: (0, jsx_runtime_1.jsx)(SPContainer, Object.assign({ style: { height: 24 } }, { children: "SP" })) }))] }), (0, jsx_runtime_1.jsxs)(BodyContainer, { children: [(0, jsx_runtime_1.jsxs)(HeaderContainer, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("b", { children: name }) }), (0, jsx_runtime_1.jsx)(TimeContainer, Object.assign({ overdue: isOverdue }, { children: isOverdue ? `Past due ${dueDate === null || dueDate === void 0 ? void 0 : dueDate.toDateString()}` : timeSinceTrigger }))] }), (0, jsx_runtime_1.jsxs)("div", { children: [dueDate ? `Due ${dueDate.toDateString()} - ` : '', triggerType === 'Program Event' ? programEventName : triggerType] }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(fos_ui_1.RMItemTag, { itemName: item.itemName, itemID: item.itemID, itemTypeID: item.itemTypeID, abbreviation: item.abbreviation }) }), (0, jsx_runtime_1.jsxs)(ButtonContainer, { children: [validOperations && validOperations.length > 1 &&
                                (0, jsx_runtime_1.jsx)(DropdownOperationButton, { onOperation: onOperationWrapper, notificationID: notificationID, options: validOperations, defaultOperation: validOperations[0], disabled: operationInProgress }), validOperations && validOperations.length === 1 &&
                                (0, jsx_runtime_1.jsx)(fos_ui_1.Button, Object.assign({ onClick: () => { onOperationWrapper(validOperations[0], notificationID); }, buttonStyle: 'SECONDARY', disabled: operationInProgress }, { children: validOperations[0] }))] })] })] }));
};
exports.default = DefaultNotification;
const Container = styled_components_1.default.div `
    font-family: ${({ theme }) => theme.fonts.robotoMedium};
    font-size: 13px;
    border: 1px solid ${({ theme }) => theme.colors.NTDarkGrey[100]};
    display: flex;
    flex-direction: row;
    max-height: 144px;
    background: white;
`;
const IconContainer = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px 11px;
    && .error-icon {
        color: ${({ theme }) => theme.colors.red[700]};
    }
`;
const SPContainer = styled_components_1.default.div `
    height: 24px;
    display: flex;
    align-items: center;
`;
const CircleLetterIcon = styled_components_1.default.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 8px;
    font-size: 10px;
    font-weight: 700;
    color: white;
    background: ${({ theme, letter }) => {
    switch (letter) {
        case 'i':
            return theme.colors.aqua[500];
        case 'A':
            return theme.colors.darkBlue[500];
        case 'T':
            return theme.colors.purple[500];
        default:
            return theme.colors.aqua[500];
    }
}};
`;
const BodyContainer = styled_components_1.default.div `
    padding: 16px 8px 16px 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    && > *:not(:first-child) {
        margin-top: 8px;
    }
`;
const HeaderContainer = styled_components_1.default.div `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex: 1;
`;
const TimeContainer = styled_components_1.default.div `
    margin-left: 8px;
    font-size: 1.2rem;
    color: ${({ theme, overdue }) => overdue
    ? theme.colors.red[700]
    : theme.colors.NTDarkGrey[550]};
`;
const ButtonContainer = styled_components_1.default.div `
    min-height: 32px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    & .MuiButton-root {
        margin-left: 5px;
    }
`;
// eslint-disable-next-line max-lines-per-function
const DropdownOperationButton = ({ notificationID, options, defaultOperation, onOperation, disabled, }) => {
    const [selectedOperation, setSelectedOperation] = (0, react_1.useState)(defaultOperation || options[0] || 'View');
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const onClickDropdown = (event) => {
        setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget);
    };
    const onClose = () => {
        setAnchorEl(null);
    };
    const onSelect = (operation) => {
        onOperation(operation, notificationID);
        onClose();
    };
    const remainingOptions = (0, react_1.useMemo)(() => options.filter(option => option !== selectedOperation), [options, selectedOperation]);
    return (0, jsx_runtime_1.jsxs)(DropdownButtonContainer, { children: [(0, jsx_runtime_1.jsx)(fos_ui_1.Button, Object.assign({ className: 'operationButton', onClick: () => { onOperation(selectedOperation, notificationID); }, buttonStyle: 'SECONDARY', disabled: disabled }, { children: selectedOperation })), (0, jsx_runtime_1.jsx)(fos_ui_1.Button, { className: 'dropdownButton', icon: 'menu_down', buttonStyle: 'SECONDARY', onClick: onClickDropdown, disabled: disabled }), (0, jsx_runtime_1.jsx)(fos_ui_1.Dropdown, Object.assign({ anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, anchorEl: anchorEl, open: !!anchorEl, onClose: onClose }, { children: remainingOptions.map((option) => (0, jsx_runtime_1.jsx)(fos_ui_1.SelectableListItem, { label: option, isSelected: false, onClick: () => { onSelect(option); } }, option)) }))] });
};
const DropdownButtonContainer = styled_components_1.default.div `
    && .dropdownButton {
        margin-left: 0;
        border-left: none;
        padding: 0 0.8rem 0 0.8rem;
        min-width: 32px;
        && .button_icon {
            margin-right: none;
        }
    }
`;
